// actions.js

import axios from 'axios';
import Cookies from 'js-cookie';


export default {

    async fetchGetTasks(ctx){
        const access_token = ctx.rootGetters.access_token;
        const config = {
            headers: {
                'Authorization': `${access_token}`
            }
        };
        try {
            const response = await axios.get(`${process.env.VUE_APP_APIGATEWAY}/api/v1/tasks`, config);
            ctx.commit('updateTasksList', response.data) ;
        } catch (error) {
            return error;
        }
    },
    async fetchGetTask(ctx, payload){
        const access_token = ctx.rootGetters.access_token;
        const config = {
            headers: {
                'Authorization': `${access_token}`
            }
        };
        try {
            const response = await axios.get(`${process.env.VUE_APP_APIGATEWAY}/api/v1/tasks/${payload.id}`, config);
            return response.data
        } catch (error) {
            return error;
        }
    },
    async fetchUpdateTask({ rootGetters, commit }, payload){
        const access_token = rootGetters.access_token;
        let finalPayload = {}
        if(payload.updated_by){
            finalPayload.updated_by = payload.updated_by
        }
        if(payload.viewed_at){
            finalPayload.viewed_at = payload.viewed_at
        }
        if(payload.status){
            finalPayload.status = payload.status
        }
        //console.log('finalPayload: ', finalPayload) 
        const config = {
            headers: {
                'Authorization': `${access_token}`
            }
        };
        try {
            const response = await axios.put(`${process.env.VUE_APP_APIGATEWAY}/api/v1/tasks/${payload.id}`,finalPayload, config);
            commit('updateTask', payload)
            return response.data
        } catch (error) {
            return error;
        }
    },
    async fetchDeleteTask({ rootGetters, commit }, payload){
        const access_token = rootGetters.access_token;
        const config = {
            headers: {
                'Authorization': `${access_token}`
            }
        };
        try {
            const response = await axios.delete(`${process.env.VUE_APP_APIGATEWAY}/api/v1/tasks/${payload.id}`, config);
            // Обновляем список задач после удаления
            commit('removeTaskFromList', payload.id);
            return response.data
        } catch (error) {
            return error;
        }
    },
    async fetchAddComment({rootGetters, commit}, payload){
        const access_token = rootGetters.access_token;
        const config = {
            headers: {
                'Authorization': `${access_token}`
            }
        };
        try {
            const response = await axios.post(`${process.env.VUE_APP_APIGATEWAY}/api/v1/tasks/comments`,payload, config);
            return response.data
        } catch (error) {
            return error;
        }
    },
    async fetchDeleteComment({rootGetters, commit}, payload){
        const access_token = rootGetters.access_token;
        const config = {
            headers: {
                'Authorization': `${access_token}`
            },
            data:{
                user_id: parseInt(localStorage.getItem('userId'))
            }
        };
        try {
            const response = await axios.delete(`${process.env.VUE_APP_APIGATEWAY}/api/v1/tasks/comments/${payload.id}`, config);
            return response.data
        } catch (error) {
            return error;
        }
    }
};
